const CSMListIcon = props => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    xmlns="http://www.w3.org/2000/svg"
    fill="#A8ADB2"
    {...props}
  >
    <path d="M18.6822 20.2924L15.4033 17.0187L16.8009 15.6264L18.6603 17.4857L22.3791 13.7617L23.7715 15.1812L18.6822 20.2924ZM18.6822 13.2924L15.4033 10.0187L16.8009 8.62635L18.6603 10.4857L22.3791 6.76175L23.7715 8.18124L18.6822 13.2924ZM5.97852 18.4953V16.5047H13.9738V18.4953H5.97852ZM5.97852 11.4953V9.50468H13.9738V11.4953H5.97852Z" />
  </svg>
)

export default CSMListIcon
